export const state = () => ({
  companyId: 0
})

export const mutations = {
  setCompanyId (state, value) {
    state.companyId = value
  }
}
